import React, {useState} from 'react'
import {connect} from 'react-redux'
import {getCurrentUserMindfiles} from '../../../../state/actions/getDataActions'
import {API_ROOT} from '../../../../baseUrls'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Button from '@mui/material/Button'
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CreateMindfileForm = ({ open, closeModal, user, getCurrentUserMindfiles }) => {
  const [newMindfileName, setNewMindfileName] = useState('')
  const [isMultiUser, setIsMultiuser] = useState("0")

  const createMindfile = () => {
    const formData = new FormData()
    formData.append("name", newMindfileName)
    formData.append("group", isMultiUser)
    // formData.append("authenticity_token", user.authenticity_token)

    fetch(`${ API_ROOT }/mindfiles/create`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': user.authenticity_token},
    })
    .then(resp => resp.json())
    .finally(getCurrentUserMindfiles)
  }

  const listMindfiles = () => {
    fetch(`${ API_ROOT }/mindfiles/list`, {
      method: 'POST',
      credentials: 'include',
      headers: {'X-CSRF-Token': user.authenticity_token},
    })
    .then(resp => resp.json())
  }

  return (

    <Dialog PaperProps={{id:"mindfileCreateDialog"}} open={open} scroll="body">
      <DialogTitle>
        <div style={{display:'flex', flexWrap:'wrap-reverse', justifyContent:'space-between'}}>
          Create a new mindfile
          <IconButton onClick={() => this.closeCloseConfirmDialog()} style={{width:'2rem', height:'2rem', margin:'-0.5rem 0 0 auto'}}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will let you setup a separate mindfile on LifeNaut, which you may use to upload information for an ancestor, or a historical figure, or anyone at all!
        </DialogContentText>
        <TextField
          style={{marginBottom: '2em'}}
          label="New mindfile name"
          variant="outlined"
          value={ newMindfileName }
          onChange={ (e) => setNewMindfileName(e.target.value) }
        />
        <Typography>Would you like to let other people collaborate on this mindfile?</Typography>
        <RadioGroup value={ isMultiUser } onChange={(e) => setIsMultiuser(e.target.value)}>
          <FormControlLabel value="1" control={<Radio />} label="Yes" />
          <FormControlLabel value="0" control={<Radio />} label="No" />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={ () => {
            createMindfile()
            closeModal()
          }}
        >
          Create
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={ () => {closeModal();listMindfiles();} }
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = state => ({
  user: state.auth,
})

const mapDispatchToProps = {
  getCurrentUserMindfiles
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateMindfileForm)
